// Local: npm start  ·  Local con backend de la nube: npm run start:nube
// Producción: npm run build  ·  Hosting temporal (desitsystem.com/tu-sala/admin): npm run build:hosting-temporal
import { DEPLOY_TARGET } from './deploy-target';

// "local" solo cuando el backend también corre en tu máquina.
const USE_LOCAL_SERVICES = DEPLOY_TARGET === 'local';
// El panel corre en tu máquina (npm start / npm run start:nube).
const USE_LOCAL_FRONTENDS = DEPLOY_TARGET !== 'production';

export const environment = {
  production: true,
  deployTarget: DEPLOY_TARGET,
  apiUrl: USE_LOCAL_SERVICES
    ? 'http://localhost:2021/v1'
    : 'https://tusala-backend-35546230649.northamerica-south1.run.app/v1',
  clientAppUrl: USE_LOCAL_FRONTENDS ? 'http://localhost:4300' : 'https://app.tusala.net',
};
